import { MeasurementUnitsCategory } from '~/enums';
import { IEditActivityDTO } from '~/types/dtos';

import { DefaultInputMetrics } from './DefaultInputMetrics';
import { StepsMetrics } from './StepsMetrics';
import { ActivityMetricsProps } from './types';

export const handleShowUnitField = ({
  control,
  fields,
  options,
  isEditing,
  watch,
  addOneForm,
  handleOpenModalInformation,
}: ActivityMetricsProps<IEditActivityDTO>) => {
  const activityMetricSelectedId: string = watch('measurementUnit') as string;

  const getCategory = () => {
    const lookup: { [key: string]: string } = {};
    for (const category of options) {
      for (const option of category.options) {
        lookup[option.value] = category.label;
      }
    }
    return lookup[activityMetricSelectedId];
  };

  const category = getCategory();

  console.log({ category });

  const isStep = options[0]?.options[0]?.label === 'Steps';

  const activityMetrics = {
    [MeasurementUnitsCategory.Time]: {
      helperText: 'Can only be set/changed on newly created activities',
      label: 'Target hours',
      placeholder: 'Type the number',
      isEditing,
      control,
    },
    [MeasurementUnitsCategory.Weight]: {
      helperText: 'Can only be set/changed on newly created activities',
      label: 'Target weight',
      placeholder: 'Type the number',
      isEditing,
      control,
    },
    [MeasurementUnitsCategory.Completion]: {
      helperText: 'Can only be set/changed on newly created activities',
      addOneForm,
      fields,
      control,
      isEditing,
    },
    [MeasurementUnitsCategory.CustomUnit]: {
      helperText: 'Can only be set/changed on newly created activities',
      label: 'Target amount',
      placeholder: 'Type the number',
      isEditing,
      control,
    },
    [MeasurementUnitsCategory.Currency]: {
      helperText: 'Can only be set/changed on newly created activities',
      label: 'Target amount',
      placeholder: 'Type the number',
      isEditing,
      control,
    },
    [MeasurementUnitsCategory.Digital]: {
      helperText: 'Can only be set/changed on newly created activities',
      label: 'Target amount',
      placeholder: 'Type the number',
      isEditing,
      control,
    },
    [MeasurementUnitsCategory.Object]: {
      helperText: 'Can only be set/changed on newly created activities',
      label: 'Target amount',
      placeholder: 'Type the number',
      isEditing,
      control,
    },
    [MeasurementUnitsCategory.Social]: {
      helperText: 'Can only be set/changed on newly created activities',
      label: 'Target amount',
      placeholder: 'Type the number',
      isEditing,
      control,
    },
    [MeasurementUnitsCategory.PersonalActs]: {
      helperText: 'Can only be set/changed on newly created activities',
      label: 'Target amount',
      placeholder: 'Type the number',
      isEditing,
      control,
    },
    [MeasurementUnitsCategory.Metric]: {
      helperText: 'Can only be set/changed on newly created activities',
      label: 'Target amount',
      placeholder: 'Type the number',
      isEditing,
      control,
    },
  };

  const renderMetricComponent = (category: MeasurementUnitsCategory) =>
    ({
      [MeasurementUnitsCategory.Time]: (
        <DefaultInputMetrics
          control={control}
          isEditing={isEditing}
          label={activityMetrics[MeasurementUnitsCategory.Time]?.label}
          placeholder={
            activityMetrics[MeasurementUnitsCategory.Time]?.placeholder
          }
          helperText={
            activityMetrics[MeasurementUnitsCategory.Time]?.helperText
          }
          handleOpenHelpIcon={handleOpenModalInformation}
        />
      ),
      [MeasurementUnitsCategory.Weight]: (
        <DefaultInputMetrics
          control={control}
          isEditing={isEditing}
          label={activityMetrics[MeasurementUnitsCategory.Weight]?.label}
          placeholder={
            activityMetrics[MeasurementUnitsCategory.Weight]?.placeholder
          }
          helperText={
            activityMetrics[MeasurementUnitsCategory.Weight]?.helperText
          }
          handleOpenHelpIcon={handleOpenModalInformation}
        />
      ),
      [MeasurementUnitsCategory.Completion]: (
        <StepsMetrics
          control={control}
          isEditing={isEditing}
          addOneForm={addOneForm}
          fields={fields}
        />
      ),
      [MeasurementUnitsCategory.CustomUnit]: (
        <DefaultInputMetrics
          control={control}
          isEditing={isEditing}
          label={activityMetrics[MeasurementUnitsCategory.CustomUnit]?.label}
          placeholder={
            activityMetrics[MeasurementUnitsCategory.CustomUnit]?.placeholder
          }
          helperText={
            activityMetrics[MeasurementUnitsCategory.CustomUnit]?.helperText
          }
          handleOpenHelpIcon={handleOpenModalInformation}
        />
      ),
      [MeasurementUnitsCategory.Currency]: (
        <DefaultInputMetrics
          control={control}
          isEditing={isEditing}
          label={activityMetrics[MeasurementUnitsCategory.Currency]?.label}
          placeholder={
            activityMetrics[MeasurementUnitsCategory.Currency]?.placeholder
          }
          helperText={
            activityMetrics[MeasurementUnitsCategory.Currency]?.helperText
          }
          handleOpenHelpIcon={handleOpenModalInformation}
        />
      ),
      [MeasurementUnitsCategory.Digital]: (
        <DefaultInputMetrics
          control={control}
          isEditing={isEditing}
          label={activityMetrics[MeasurementUnitsCategory.Digital]?.label}
          placeholder={
            activityMetrics[MeasurementUnitsCategory.Digital]?.placeholder
          }
          helperText={
            activityMetrics[MeasurementUnitsCategory.Digital]?.helperText
          }
          handleOpenHelpIcon={handleOpenModalInformation}
        />
      ),
      [MeasurementUnitsCategory.Object]: (
        <DefaultInputMetrics
          control={control}
          isEditing={isEditing}
          label={activityMetrics[MeasurementUnitsCategory.Object]?.label}
          placeholder={
            activityMetrics[MeasurementUnitsCategory.Object]?.placeholder
          }
          helperText={
            activityMetrics[MeasurementUnitsCategory.Object]?.helperText
          }
          handleOpenHelpIcon={handleOpenModalInformation}
        />
      ),
      [MeasurementUnitsCategory.Social]: (
        <DefaultInputMetrics
          control={control}
          isEditing={isEditing}
          label={activityMetrics[MeasurementUnitsCategory.Social]?.label}
          placeholder={
            activityMetrics[MeasurementUnitsCategory.Social]?.placeholder
          }
          helperText={
            activityMetrics[MeasurementUnitsCategory.Social]?.helperText
          }
          handleOpenHelpIcon={handleOpenModalInformation}
        />
      ),
      [MeasurementUnitsCategory.PersonalActs]: (
        <DefaultInputMetrics
          control={control}
          isEditing={isEditing}
          label={activityMetrics[MeasurementUnitsCategory.PersonalActs]?.label}
          placeholder={
            activityMetrics[MeasurementUnitsCategory.PersonalActs]?.placeholder
          }
          helperText={
            activityMetrics[MeasurementUnitsCategory.PersonalActs]?.helperText
          }
          handleOpenHelpIcon={handleOpenModalInformation}
        />
      ),
      [MeasurementUnitsCategory.Metric]: (
        <DefaultInputMetrics
          control={control}
          isEditing={isEditing}
          label={activityMetrics[MeasurementUnitsCategory.Metric]?.label}
          placeholder={
            activityMetrics[MeasurementUnitsCategory.Metric]?.placeholder
          }
          helperText={
            activityMetrics[MeasurementUnitsCategory.Metric]?.helperText
          }
          handleOpenHelpIcon={handleOpenModalInformation}
        />
      ),
    }[category]);

  if (isStep) {
    return (
      <StepsMetrics
        control={control}
        isEditing={isEditing}
        addOneForm={addOneForm}
        fields={fields}
      />
    );
  }

  return renderMetricComponent(category as MeasurementUnitsCategory) ?? null;
};
